<span class="version">PSSR v{{appVersion}}</span>
